/**
 * 密码输入框
 */
export default {
  name: 'password',
  label: '密码框',
  icon: 'el-icon-question',
  config: [{
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请输入密码'
    } // }, {
    //   xtype: 'number',
    //   options: {
    //     label: '最大长度限制',
    //     name: 'maxLength',
    //     default: 32
    //   }

  }]
};